import { css } from '@/styled-system/css';

export const upsellBannerActionStyles = css.raw({
  flexShrink: 0,
  marginBlockStart: {
    lgDown: 'tighter',
  },
  marginInlineEnd: {
    lg: 'default',
  },
});
